import { ListBase } from 'react-admin';
import { MissionListLayout } from './MissionListLayout';

export const MissionList = () => {
    return (
        <ListBase
            resource="mission"
            perPage={25}
            sort={{ field: 'updatedAt', order: 'DESC' }}
        >
            <MissionListLayout />
        </ListBase>
    );
};
